
import { z } from "zod";

export const EscalationSubStatusValues = ["WAITING_ON_REMI", "WAITING_ON_SUNRUN", "WAITING_ON_THIRD_PARTY", "WAITING_ON_CONTRACTOR", "WAITING_ON_CUSTOMER", "WAITING_ON_FINAL_INSPECTION", "DATE_SET"] as const;
export const EscalationSubStatusSchema = z.enum(EscalationSubStatusValues);
export const EscalationSubStatus = EscalationSubStatusSchema.enum;
export type EscalationSubStatus = (typeof EscalationSubStatusValues)[number];
